<template>
  <v-dialog
    v-model="phoneDialog"
    no-click-animation
    overlay-color="rgba(39, 50, 64)"
    overlay-opacity="0.6"
    :fullscreen="$vuetify.breakpoint.xs ? true : false"
    persistent
    width="500"
    :transition="false"
  >
    <v-card>
      <v-card-title>
        <span v-if="mandatory">{{ $t('packs.almostDone') }}</span>
        <v-spacer />
        <v-btn
          v-if="!mandatory"
          icon
          @click="phoneDialog = false"
        >
          <v-icon v-if="!mandatory">
            mdi-close
          </v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-form>
          <v-layout wrap>
            <v-flex
              xs12
            >
              <v-text-field
                id="phone"
                v-model.trim="phone"
                name="phone"
                prefix="+"
                :label="$t('profile.phone')"
                :error-messages="phoneError"
                @blur="$v.phone.$touch()"
              >
                <template #append>
                  <v-tooltip top>
                    <template #activator="{ on }">
                      <small v-on="on">{{ $t('profile.phoneWhy') }}</small>
                    </template>
                    {{ $t('profile.phoneTooltip') }}
                  </v-tooltip>
                </template>
              </v-text-field>
            </v-flex>
            <v-flex mt-3>
              <v-text-field
                id="support-verification-code"
                v-model.trim="support_verification_code"
                name="support-verification-code"
                :label="$t('profile.supportCode')"
                :placeholder="$t('profile.supportCodePlaceholder')"
                :error-messages="codeError"
                :type="showCode ? 'text' : 'password'"
                @input="$v.support_verification_code.$touch()"
                @blur="$v.support_verification_code.$touch()"
              >
                <template #append>
                  <v-icon
                    style="margin-right:4px;"
                    @click="showCode = !showCode"
                  >
                    {{ showCode ? 'mdi-eye' : 'mdi-eye-off' }}
                  </v-icon>
                  <v-tooltip top>
                    <template #activator="{ on }">
                      <v-icon v-on="on">
                        mdi-information-outline
                      </v-icon>
                    </template>
                    {{ $t('profile.supportCodeHint') }}
                  </v-tooltip>
                </template>
              </v-text-field>
            </v-flex>
          </v-layout>
        </v-form>
      </v-card-text>
      <v-divider />

      <v-card-actions>
        <v-spacer />

        <v-btn
          class="primary"
          :disabled="loading"
          :loading="loading"
          @click="save()"
        >
          {{ $t('globals.saveButton') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ADD_PHONE_MUTATION from "@/graphql/mutations/AddPhone.gql";
import { validationMixin } from "vuelidate";
import {
  required,
  numeric,
  minLength,
  maxLength
} from "vuelidate/lib/validators";
import PhoneNumber from "awesome-phonenumber";
import { mapMutations, mapGetters } from "vuex";

const check_phone = phone => {
  if (phone == null || phone == "") return false;
  const country = PhoneNumber( '+'+phone ).getRegionCode();
  if (country == "ZZ") return false;
  const pn = new PhoneNumber(phone, country);
  return pn.isMobile();
};

export default {
  name: "HelperAddPhone",
  mixins: [validationMixin],
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    mandatory: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    loading: false,
    phone: null,
    support_verification_code: null,
    showCode: false
  }),
  validations() {
    return {
      phone: {
        required,
        check_phone
      },
      support_verification_code: {
        required,
        numeric,
        minLength: minLength(6),
        maxLength: maxLength(6)
      }
    };
  },
  computed: {
    ...mapGetters("user", ["getUser"]),
    phoneDialog: {
      get() {
        return this.showDialog;
      },
      set(val) {
        this.$emit("closePhoneDialog", val);
      }
    },
    convertedNumber() {
      const country = PhoneNumber( '+'+this.phone ).getRegionCode();
      const pn = new PhoneNumber(
        this.phone,
        country
      );
      return '+'+pn.getNumber();
    },
    phoneError() {
      const errors = [];
      if (!this.$v.phone.$dirty) return errors;
      !this.$v.phone.required && errors.push(this.$t("profile.reqField"));
      !this.$v.phone.check_phone &&
        errors.push(this.$t("profile.phoneBadFormat"));
      return errors;
    },
    codeError() {
      const errors = [];
      if (!this.$v.support_verification_code.$dirty) return errors;
      !this.$v.support_verification_code.required &&
        errors.push(this.$t("profile.reqField"));
      (!this.$v.support_verification_code.numeric ||
        !this.$v.support_verification_code.minLength ||
        !this.$v.support_verification_code.maxLength) &&
        errors.push(this.$t("profile.supportCodeError"));
      return errors;
    }
  },
  mounted() {
    this.$store.subscribe((mutation) => {
      if (mutation.type == "user/setUser" && this.getUser) {
        this.phone = this.getUser.calling_code || "1";
      }
    });
    if (this.getUser) {
      this.phone = this.getUser.calling_code || "1";
    }
  },
  methods: {
    ...mapMutations("user", ["setUserPhone"]),
    open() {
      this.dialog = true;
    },
    save() {
      this.$v.$touch();
      if (this.$v.$invalid) return;

      this.loading = true;
      this.$apollo
        .mutate({
          mutation: ADD_PHONE_MUTATION,
          variables: {
            phone: this.convertedNumber,
            support_verification_code: this.support_verification_code
          }
        })
        .then(data => {
          this.setUserPhone(data.data.updateUser.obfuscated_phone);
          this.phoneDialog = false;
          this.loading = false;
          window.tidioChatApi.setVisitorData({
            phone: data.data.updateUser.phone
          });
        })
        .catch(error => {
          this.errorHandler(error);
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
